import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ref", "as", "name", "alternateBackground", "background", "backgroundColor", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import Box from 'components/Box';
import ThemeSection from 'components/ThemeSection';
import { jsx as _jsx } from "react/jsx-runtime";
export var ThemedBox = function ThemedBox(_ref) {
  var ref = _ref.ref,
    as = _ref.as,
    name = _ref.name,
    alternateBackground = _ref.alternateBackground,
    background = _ref.background,
    backgroundColor = _ref.backgroundColor,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var getAutomaticBgColor = function getAutomaticBgColor(theme) {
    return alternateBackground && theme.backgroundAlt ? theme.backgroundAlt : theme.background;
  };
  return /*#__PURE__*/_jsx(ThemeSection, {
    name: name,
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      ref: ref,
      as: as || 'div'
    }, otherProps), {}, {
      textColor: "text",
      backgroundColor: background || backgroundColor || getAutomaticBgColor,
      children: children
    }))
  });
};
ThemedBox.displayName = 'ThemedBox';
export default ThemedBox;